/**
 * @unidev-hub/api-framework
 *
 * A comprehensive framework for building API services with Express,
 * providing standardized startup, configuration, authentication,
 * database connections, health checks, and documentation.
 */

// Export core API functionality
export { createApi } from './core';

export * from './middleware';


// Export types - they take precedence for the original type names
export * from './types';

// Export startup functionality for service initialization
export * from './startup';

// Export constants
export * from './constants';

// Export utilities
export * from './utils';

// Export documentation utilities
export * from './docs';

// Re-export health functionality from @unidev-hub/health
export {
  // Core health components
  Status,
  HealthService,
  HealthIndicator,

  // Health indicators
  MemoryHealthIndicator,
  DiskHealthIndicator,
  HttpHealthIndicator,
  DatabaseHealthIndicator,

  // Middleware and endpoints
  createHealthEndpoint,


  // New history tracking
  HealthHistoryService
} from '@unidev-hub/health';

// Re-export health types
export type {
  // Result types
  HealthResult,
  AggregatedHealthResult,

  // Configuration types
  HealthHistoryOptions,
  HealthHistoryRecord,
  EnhancedHealthEndpointOptions,
  HealthDashboardProps
} from '@unidev-hub/health';
